import {Component, Inject, OnInit} from '@angular/core';
import {AppService} from "../../app.service";
import {UtilsService} from "../utils.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {SitesSelectorComponent} from "../sites-selector/sites-selector.component";
import {NetworkedAccountsSelectorComponent} from "../networked-accounts-selector/networked-accounts-selector.component";
import {NetworkedUsersSelectorComponent} from "../networked-users-selector/networked-users-selector.component";
import {AssetsSelectorComponent} from "../assets-selector/assets-selector.component";

/**
 * Filter dialog for the Safety Observations selector. Mirrors the main
 * Safety Observations list filters so the selector can be narrowed down
 * the same way the register list is.
 */
@Component({
  selector: 'app-safety-observations-selector-filter',
  templateUrl: './safety-observations-selector-filter.component.html',
  styleUrls: ['./safety-observations-selector-filter.component.scss']
})
export class SafetyObservationsSelectorFilterComponent implements OnInit {

  so_category: string = '';
  so_type: string = '';
  so_priority: string = '';
  so_status: string = '';
  so_rating: string = '';
  selected_site_ids: number[] = [];
  selected_contractor_ids: number[] = [];
  selected_user_ids: number[] = [];
  selected_asset_ids: number[] = [];
  selected_reported_by_ids: number[] = [];
  date_filter_range: Date[] = [];
  hide_assets: boolean = false;

  constructor(
    public app: AppService,
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SafetyObservationsSelectorFilterComponent>
  ) { }

  ngOnInit() {
    this.so_category = this.data['so_category'] || '';
    this.so_type = this.data['so_type'] || '';
    this.so_priority = this.data['so_priority'] || '';
    this.so_status = this.data['so_status'] || '';
    this.so_rating = this.data['so_rating'] || '';
    this.selected_site_ids = this.data['site_ids'] || [];
    this.selected_contractor_ids = this.data['contractor_ids'] || [];
    this.selected_user_ids = this.data['user_ids'] || [];
    this.selected_asset_ids = this.data['asset_ids'] || [];
    this.selected_reported_by_ids = this.data['reported_by_ids'] || [];
    this.date_filter_range = (this.data['date_filter_range'] || []).map((date: Date | string) => new Date(date));
    this.hide_assets = this.data['hide_assets'] || false;
  }

  getOutputDateRange($event) {
    this.date_filter_range = $event;
  }

  onSelectSites() {
    this.utils.showComponentDialog(
      SitesSelectorComponent,
      { selected: this.selected_site_ids, multiple: true },
      { width: '1200px' },
      (results) => {
        if (!results) { return; }
        this.selected_site_ids = results;
      }
    );
  }

  onSelectContractors() {
    this.utils.showComponentDialog(
      NetworkedAccountsSelectorComponent,
      { selected: this.selected_contractor_ids, multiple: true },
      { width: '1200px' },
      (results: number[]) => {
        if (!results) { return; }
        this.selected_contractor_ids = results;
      }
    );
  }

  onSelectUsers() {
    this.utils.showComponentDialog(
      NetworkedUsersSelectorComponent,
      { selected: this.selected_user_ids, multiple: true, selectedAccountId: this.app.account.id, visitors_from_all_sites: true },
      { width: '1200px' },
      (results: number[]) => {
        if (!results) { return; }
        this.selected_user_ids = results;
      }
    );
  }

  onSelectReportedBy() {
    this.utils.showComponentDialog(
      NetworkedUsersSelectorComponent,
      { selected: this.selected_reported_by_ids, multiple: true, visitors_from_all_sites: true },
      { width: '1200px' },
      (results: number[]) => {
        if (!results) { return; }
        this.selected_reported_by_ids = results;
      }
    );
  }

  onSelectAssets(): void {
    this.utils.showComponentDialog(
      AssetsSelectorComponent,
      { selected: this.selected_asset_ids, multiple: true },
      { width: '1700px' },
      (results: number[]) => {
        if (!results) { return; }
        this.selected_asset_ids = results;
      }
    );
  }

  onClearDateRange() {
    this.date_filter_range = [];
  }

  onClearAndClose() {
    this.so_category = '';
    this.so_type = '';
    this.so_priority = '';
    this.so_status = '';
    this.so_rating = '';
    this.selected_site_ids = [];
    this.selected_contractor_ids = [];
    this.selected_user_ids = [];
    this.selected_asset_ids = [];
    this.selected_reported_by_ids = [];
    this.date_filter_range = [];

    this.onSaveAndClose();
  }

  onSaveAndClose() {
    this.dialogRef.close({
      so_category: this.so_category,
      so_type: this.so_type,
      so_priority: this.so_priority,
      so_status: this.so_status,
      so_rating: this.so_rating,
      site_ids: this.selected_site_ids,
      contractor_ids: this.selected_contractor_ids,
      user_ids: this.selected_user_ids,
      asset_ids: this.selected_asset_ids,
      reported_by_ids: this.selected_reported_by_ids,
      date_filter_range: this.date_filter_range
    });
  }
}
